export default __webpack_public_path__ + "static/media/OTsurgeryConvertDisable.610fb4ba.svg";